module.exports = __webpack_public_path__ + "media/images/emblems/Gaiserwald-blazono-7d656c98e10d3bff71de1c9f95b3c2d8.png";